import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
//import DAASLogo from '../assets/DAAS-logo.png'; // adjust path if needed
import DAASImage from '../assets/DAAS.png'; // adjust path if needed

const TAAS = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const titleRef = useRef(null);
  const iconRef = useRef(null);
  const introRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);

  const handleNavigate = (path) => {
    navigate(path);
    // Scroll to top after navigation
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-visible');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all animated elements
    const elementsToObserve = [
      imageRef.current,
      titleRef.current,
      iconRef.current,
      introRef.current,
      descriptionRef.current,
      buttonRef.current
    ];

    elementsToObserve.forEach((element) => {
      if (element) {
        observer.observe(element);
      }
    });

    // Cleanup observer on component unmount
    return () => {
      elementsToObserve.forEach((element) => {
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  return (
    <section className="taas" ref={sectionRef}>
      <div className="container taas-container">
        <div 
          className="taas-home-section-image animate-fade-in-left" 
          ref={imageRef}
        >
          <img src={DAASImage} alt="DAAS" className="DAAS-image" /> 
        </div>
        
        <div className="section-content">
          <div 
            className="TAAS-product-header slide-in-right" 
            ref={titleRef}
            style={{ animationDelay: '0.2s' }}
          >
            <div className="TAAS-logo-with-underline">
              <span className="TAAS-home-product-subtitle">
              Data Analytics and Solutions
              </span>
            </div>                      
          </div>
          <p 
            className="taas-home-feature-intro animate-fade-in-up animate-delay-3" 
            ref={introRef}
          >
             <h2>Need a tailored solution for a specific project?</h2>
            <p> Our Data Analytics and Solutions offers customised solutions to meet the unique needs of our clients. Our team of experts brings extensive knowledge in business intelligence, automation, and workflow optimization. By tailoring our services, we enhance client operations and improve overall performance.</p>
          </p>
          
          <p 
            className="feature-description animate-fade-in-up animate-delay-4" 
            ref={descriptionRef}
          >
            Our data-driven approach helps clients streamline processes, increase efficiency, and make informed decisions. Leveraging advanced technologies and best practices, we enable our clients to stay competitive and achieve their business objectives.
          </p>
          
          <button 
            className="explore-button animate-fade-in-up animate-delay-5" 
            onClick={() => handleNavigate('/daas')}
            ref={buttonRef}
          >
            Discover DAAS
          </button>
        </div>
      </div>
    </section>
  );
};

export default TAAS;